import { NumberInput } from '@angular/cdk/coercion';
import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { DeclarationService } from 'src/app/pages/privado/services/saude/declaration.service';
import { TipoProduto } from '../../enum/tipo-produto';
@Component({
  selector: 'app-historico-declaracao',
  templateUrl: './historico-declaracao.component.html',
  styleUrls: ['./historico-declaracao.component.css']
})
export class HistoricoDeclaracaoComponent {
  get product() { return TipoProduto; }
  faDownload = faDownload;
  modelsList: Array<any> = [];
  listaDeclaracoes: any;
  loading: boolean = false;
  loadingDownload: boolean = false;
  productsList: Array<any> = [];
  idCurrentDownload!: any;
  tipoDeclaracao!: number;
  filter: any = { ItemsPerPage: 5, Page: 0, IsPaginated: true };
  formData: FormGroup = new FormGroup({
    productId: new FormControl(null),
    typeId: new FormControl(null),
    protocol: new FormControl(null),
    ItemsPerPage: new FormControl(5),
    page: new FormControl(0),
  });
  constructor(private declarationService: DeclarationService, private route: ActivatedRoute) {
    this.getAllProducts();
  }
  downloadDeclaracao(code: any) { }
  getModels() {
    this.loading = true;
    this.declarationService.getModelsUser(Number(this.formData.value.productId)).subscribe({
      next: (res: any) => { this.modelsList = res; this.loading = false; },
      error: () => { this.loading = false; }
    });
  }
  getAllProducts() {
    this.loading = true;
    this.declarationService.getProducts().subscribe({
      next: (products: any) => { this.productsList = products; this.loading = false; },
      error: () => { this.loading = false; }
    });
  }
  load() {
    this.declarationService.getDeclarations(this.formData.value).subscribe((res: any) => {
      this.listaDeclaracoes = res.items;
    })
  }
  download(request: any, currentId: number) {
    this.idCurrentDownload = currentId;
    this.loadingDownload = true;
    this.declarationService.getDeclaration(request.code).subscribe((data) => {
      const a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      a.download = "Declaração de " + request.product + " - " + request.model + ".pdf";
      a.href = URL.createObjectURL(data);
      a.target = '_blank';
      a.click();
      document.body.removeChild(a);
      this.loadingDownload = false;
      this.idCurrentDownload = null;
    });
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.formData.get('ItemsPerPage')?.setValue(quantidade);
    this.load();
  }
  onChangePagination(page: number) {
    this.formData.get('page')?.setValue(page);
    this.load();
  }
}
